// NOTE: Aliases to classes and interfaces are used for external consumption.

// SDK exports.
import ISigner from './interfaces/ISigner.js';
import IonDid from './IonDid.js';
import IonDocumentModel from './models/IonDocumentModel.js';
import IonKey from './IonKey.js';
import IonNetwork from './enums/IonNetwork.js';
import IonPublicKeyModel from './models/IonPublicKeyModel.js';
import IonPublicKeyPurpose from './enums/IonPublicKeyPurpose.js';
import IonRequest from './IonRequest.js';
import IonSdkConfig from './IonSdkConfig.js';
import IonServiceModel from './models/IonServiceModel.js';
import JwkEd25519 from './models/JwkEd25519.js';
import JwkEs256k from './models/JwkEs256k.js';
import LocalSigner from './LocalSigner.js';

export {
  ISigner,
  IonDid,
  IonDocumentModel,
  IonKey,
  IonNetwork,
  IonPublicKeyModel,
  IonPublicKeyPurpose,
  IonRequest,
  IonSdkConfig,
  IonServiceModel,
  JwkEd25519,
  JwkEs256k,
  LocalSigner
};
